import { LocationAcuityDescription } from '@quromedical/fhir-common';
import { Location } from '@quromedical/models';
import { FormCard, RowConfig } from 'design-system';
import React from 'react';
import { strings } from 'strings';

import { getDescription } from './fields';

interface CardProps {
  data: Location;
  canEdit: boolean;
  onEditPress: () => void;
}

const getLocationRows = (location: Partial<Location> = {}): RowConfig[] => {
  const commonRows: RowConfig[] = [
    {
      fields: [
        {
          type: 'text',
          label: strings.LabelName,
          display: location.name,
        },
        {
          type: 'text',
          label: strings.LocationStatus,
          display: location.status,
        },
      ],
    },
    {
      fields: [
        {
          type: 'text',
          label: strings.LabelManagingOrganization,
          display: location.managingOrganization?.display,
        },
        {
          type: 'text',
          label: strings.LocationParent,
          display: location.parent?.display || strings.DefaultLocationParent,
        },
      ],
    },
    {
      fields: [
        {
          type: 'text',
          label: strings.LabelLocationType,
          display: getDescription(location.type),
        },
        {
          type: 'text',
          label: strings.LabelLocationAcuity,
          display: location.acuity
            ? `${LocationAcuityDescription[location.acuity]}`
            : strings.DisplayNotFound,
        },
      ],
    },
    {
      fields: [
        {
          type: 'text',
          label: strings.LabelLocationDescription,
          display: location.description,
        },
        {
          type: 'text',
          label: strings.LabelLocationCapacity,
          display: `${location.capacity}`,
        },
      ],
    },
  ];

  return commonRows;
};

export const GeneralCard: React.FC<CardProps> = ({ data, canEdit, onEditPress }) => {
  const rows = getLocationRows(data);

  return (
    <FormCard
      isButtonVisible={canEdit}
      onButtonPress={onEditPress}
      buttonText={strings.ButtonTextEdit}
      buttonIcon="edit"
      showIcons
      title={strings.FormLabelPersonDetails}
      rows={rows}
    />
  );
};
